import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import './user-management.css';
import { NavLink, Route } from 'react-router-dom';
import UserList from './user-list/UserList';

class UserManagement extends ComponentHelper {
	render() {
		return (
			<div className="user-management-view animated fadeIn">
				<div className="panel-header hbox vcenter">
					<div className="header-text grow-1">User Management</div>
				</div>
				<div className="tab-ctn hbox grow-1 animated fadeIn">
					<NavLink to={`/manage-users/users`} className="tab vbox vcenter hcenter">
						Users
					</NavLink>
				</div>
				<div className="tab-content">
					<Route exact path={`/manage-users/users`} component={UserList} />
				</div>
			</div>
		);
	}
}

export default UserManagement;



// WEBPACK FOOTER //
// ./src/views/user-management/UserManagement.js